export const STORE_PAYMENT_OPTIONS = [
  { value: "COD", label: "Cash on delivery" },
  { value: "COP", label: "Cash on pickup" },
  { value: "ONLINEPAYMENT", label: "Online payment" },
];
const onlineMethods = [
  "GCASH",
  "MAYA",
  "CARD",
  "SHOPEEPAY",
  "QR_PH",
  "BANK_TRANSFER",
];
export function acceptedStorePayments(methods) {
  if (!Array.isArray(methods) || !methods.length)
    return STORE_PAYMENT_OPTIONS.map((option) => option.value);
  if (methods.some((method) => onlineMethods.includes(method)))
    return [
      ...new Set([
        ...methods.filter((method) => ["COD", "COP"].includes(method)),
        "COP",
        "ONLINEPAYMENT",
      ]),
    ];
  return methods;
}
export function storeAcceptsPayment(item, method) {
  return acceptedStorePayments(
    item.store?.acceptedPaymentMethods ||
      item.acceptedPaymentMethods ||
      item.vendorId?.acceptedPaymentMethods,
  ).includes(onlineMethods.includes(method) ? "ONLINEPAYMENT" : method);
}
